
import React from 'react';
import { Navigate } from 'react-router-dom';
import CompactLayout from '@/components/layout/CompactLayout';
import { Toaster } from '@/components/ui/toaster';

const Index = () => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  
  // If not logged in, redirect to login
  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  // Show the regular Dashboard by redirecting to dashboard
  return <Navigate to="/dashboard" />;
};

export default Index;
